
import StatCard, { StatCardProps } from "./Statcard";

export interface StatsGridProps {
    items: StatCardProps[];
    columns?: {
        base?: number;
        sm?: number;
        lg?: number;
    };
}

export default function StatsGrid({
    items,
    columns = { base: 1, sm: 2, lg: 5 },
}: StatsGridProps) {
    if (!items || items.length === 0) {
        return (
            <div className="text-center text-gray-500 py-6">
                No statistics available.
            </div>
        );
    }

    const gridClasses = `
    grid gap-4 sm:gap-6 mb-6 sm:mb-8
    grid-cols-${columns.base}
    sm:grid-cols-${columns.sm}
    lg:grid-cols-${columns.lg}
  `;

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6 mb-6 sm:mb-8">
            {items.map((item, idx) => (
                <StatCard key={idx} {...item} />
            ))}
        </div>
    );
}
